import React, {useState} from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import {signInWithGoogle} from '../../App';
import googlelogo from '../Images/google.png';
import closeicon from '../Images/close.png';
import lock from '../Images/lock.svg';
import letter from '../Images/letter.svg';
import {index} from '../redux/index';
import {useNavigate} from "react-router-dom"




const LoginModal = ({isLoginModalVisible, setIsLoginModalVisible, setIsJoinModalVisible, setIsResetPasswordModalVisible}) => {
    const navigate = useNavigate();
    const [emailState, setEmailState] = useState('');
    const [passwordState, setPassword] = useState('');

    const handleEmailChange = (event) => {
        setEmailState(event.target.value);
    };
    const handlePasswordChange = (event) => {
        setPassword(event.target.value)
    }
    const onSignIn = (event) => {
        const [email, password] = [emailState, passwordState]
        firebase.auth().signInWithEmailAndPassword(email, password)
        .then((result) => {
            //console.log(result)
            index();
            window.location = '/'
        })
        .catch((error) => {
            console.log(error)
        })
        event.preventDefault();
    }
  return (
    <div>
        <Modal show={isLoginModalVisible} onHide={() => {setIsLoginModalVisible(false)}}>       
            <Modal.Body>  
                <div className='modal-outer'>
                    <div className="close-icon-div">
                        <img src={closeicon} alt="Close Icon" onClick={() => setIsLoginModalVisible(false)} className="close-icon"></img>
                    </div>
                    <div className="modal-inner">
                        <h2 className="modal-header">Log in to Cuisn</h2>
                        <button onClick={() => {signInWithGoogle(navigate)}} className="home-sign-up">
                            <img src={googlelogo} alt="Google Logo" className="google-logo"></img> 
                            <span className="google-signin">Sign in with Google</span>
                        </button>
                        <span className="modal-content">or</span>
                        <form onSubmit={onSignIn}>
                            <div className="signup-form">
                                <div className='email-div'>
                                    <Container className='email-container'>
                                        <Row>
                                            <Col xs={1} md={1} lg={1} className="person-col">
                                                <img src={letter} alt="Letter Icon" className='email-icon'></img>
                                            </Col>
                                            <Col xs={11} md={11} lg={11}>
                                                <input type="email" placeholder="Email" className="name-input" value={emailState} onChange={handleEmailChange} required></input>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <div className='password-div'>
                                    <Container className='password-container'>
                                        <Row>
                                            <Col xs={1} md={1} lg={1} className="person-col">
                                                <img src={lock} alt="Lock Icon" className='lock-icon'></img>
                                            </Col>
                                            <Col xs={11} md={11} lg={11}>
                                                <input type="text" placeholder="Password" className="name-input" value={passwordState} onChange={handlePasswordChange} required></input>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <button className='home-sign-up email-signup' type="submit" name="submit">Log in with email</button>
                            </div>
                        </form>
                        <div>
                            <p className="got-account">
                                Don't have an account?
                                <button onClick={() => {setIsLoginModalVisible(false); setIsJoinModalVisible(true)}} className="modal-link">Sign Up</button>
                            </p>
                            <p className="got-account">
                                Forgot password?
                                <button onClick={() => {setIsLoginModalVisible(false); setIsResetPasswordModalVisible(true)}} className="modal-link">Reset password</button>
                            </p>
                        </div>
                    </div>
                </div>
            </Modal.Body>  
        </Modal>  
    </div>
  )
}

export default LoginModal